import { Component, OnInit, EventEmitter } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';

declare var $:any;
declare var Materialize:any;

@Component({
  selector: 'app-apicall',
  templateUrl: './apicall.component.html',
  styleUrls: ['./apicall.component.css']
})
export class ApicallComponent implements OnInit {

  apitype = 'get';
  url;
  apidatatype;
  public formdata: any[] = [{
    formKey: undefined,
    formValue: undefined
  }];
  rawdata:any;
  // formdata:any = new FormData();
  SingleFile;
  MultipleFile:any = [];
  file = "file";

  loading = 0;

  response_modal = new EventEmitter<string | MaterializeAction>();
  apiresult;

  constructor(private apirequest: ApiRequestService) { }

  ngOnInit() {
    $(document).ready(function() {
      Materialize.updateTextFields();
    });
    this.loading = 0;
    this.setparm('get');
    this.url = '';
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  setparm(type:any) {
    this.apitype = type;
    this.apidatatype = undefined;
  }

  send(){
    this.loading = 1;
    console.log(this.url);
    console.log(this.apitype);
    
    if(this.apitype === 'get') {
      this.apirequest.apicaller(this.apitype,'',this.url).subscribe(res => {
        this.loading = 0;
        console.log(res);
        this.apiresult = res;
        this.result_view();
    },error => {
      this.loading = 0;
      let errors = error;
      this.apiresult = errors;
      this.result_view();
    });

    } else if(this.apitype === 'post' && this.apidatatype === 'raw') {
      console.log(this.rawdata);
      let data = JSON.parse(this.rawdata);
      console.log(data);
      
      this.apirequest.apicaller(this.apitype,data,this.url).subscribe(res => {
        this.loading = 0;
        console.log(res);
        this.apiresult = res;
        this.result_view();
    },error => {
      this.loading = 0;
      let errors = error;
      this.apiresult = errors;
      this.result_view();
    });
    } else {
      
      let data =  new FormData();
      for (let index = 0; index < this.formdata.length; index++) {
        data.append(this.formdata[index]['formKey'],this.formdata[index]['formValue']);
      }
      if(this.SingleFile != undefined){
        data.append(this.file,this.SingleFile);
      }

      if(this.MultipleFile.length != 0){
        for (let i = 0; i < this.MultipleFile.length; i++) {
          data.append(this.file, this.MultipleFile[i]);
        }
      }
      this.apirequest.apicaller(this.apitype,data,this.url).subscribe(res => {
        this.loading = 0;
        console.log(res);
        this.apiresult = res;
        this.result_view();
    },error => {
      this.loading = 0;
      let errors = error;
      this.apiresult = errors;
      this.result_view();
    });
      
    }
    
  }

  datatype(id,value){
    console.log(value);
    console.log(id);
    
    this.apidatatype = value;
  }


  

  addfeild() {
    this.formdata.push({
      formKey: undefined,
      formValue: undefined
    });
  }

  removefeild(i: number) {
    this.formdata.splice(i, 1);
  }

  onFileChange(event:any){
    if (event.target.files) {
      var reader = new FileReader();
      reader.onload = function(e) {
      // console.log(reader.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.SingleFile = event.target.files[0];
      if(event.target.files.length > 1) {
        let size = event.target.files.length;   
        for (let index = 0; index < size; index++) {
          this.MultipleFile.push(event.target.files[index]);       
        }
      }
      
    } 

    console.log(this.SingleFile);
    
    
   
     
   
  }




  result_view(){
    this.response_modal.emit({action: 'modal', params: ['open']});
   }
  
  result_close(){
    this.response_modal.emit({action: 'modal', params: ['close']});
   }
  
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/apicall/apicall.component.ts